import './org-chart.css';

const OrgChart = ({cards}:any) => {

  const renderCards = (cards: any[]) => {
      return cards.map((card:any) => {
        return (
          <div className="head-shot-container">
            <img src={card.image} alt={card.name} />
            <h3>{card.name}</h3>
            {card.designation && <p>{card.designation}</p>}
          </div>
        );
      });
  };

  return (
    <section className='org-chart'>
      <div className="org-chart-container">
      <div className="org-chart-heading">
        <h2>
          Our Team
        </h2>
      </div>
      <div className="org-chart-content">
        {renderCards(cards)}
      </div>
    </div>
    </section>
  )
}

export default OrgChart;